import axios from "axios";
import {REST_ENDPOINT} from "@/constants";

export const ORDER_BY = {
    DATE: "DATE",
    NAME: "NAME",
    SEARCH_SCORE: "SEARCH_SCORE"
}

function normalizeAndLowercaseString(string) {
    if (!string) return '';
    return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

export default {
    state: {
        songs: [],
        filters: {
            numberOfElements: 10,
            query: ''
        },
        orderBy: ORDER_BY.DATE
    },
    mutations: {
        setSongs(state, songs) {
            state.songs = songs;
            state.songs.forEach(song => { 
                song.searchScore = song.searchScore || 0;
                /*console.log(song.files);
                song.files.forEach(file => { song.files[file.type] = file; });*/
            });
        },
        setNumberOfElements(state, numberOfElements) {
            state.filters.numberOfElements = numberOfElements;
        },
        setQuery(state, query) {
            state.filters.query = query;
            // generating search score for each song
            if (query && query !== '') {
                state.songs.forEach(song => {
                    const normalizedName = normalizeAndLowercaseString(song.title);
                    const normalizedAuthor = normalizeAndLowercaseString(song.author)
                    const normalizedQuery = normalizeAndLowercaseString(query);
                    const normalizedText = normalizeAndLowercaseString(song.lyrics);

                    const foundInName = normalizedName.indexOf(normalizedQuery) !== -1;
                    const foundInAuthors = normalizedAuthor.indexOf(normalizedQuery) !== -1;
                    const foundInText = normalizedQuery !== '' && normalizedText.indexOf(normalizedQuery) >= 0;

                    song.searchScore = (foundInName ? 10 : 0) + (foundInAuthors ? 5 : 0) + (foundInText ? 1 : 0);
                });
            } else {
                state.songs.forEach(song => song.searchScore = 0);
            }
        },
        setOrderBy(state, orderBy) {
            state.orderBy = orderBy;
        }
    },
    actions: {
        ensureSongs(context) {
            if (!context.state.songs.length)
                context.dispatch('loadSongs');
        },
        loadSongs(context) {
            axios({
                url: `${REST_ENDPOINT}songs/`,
                method: 'GET',
                data: {
                    token: context.rootGetters.authToken
                }
            })
            .then(res => context.commit('setSongs', res.data));
        },
        setSongs(context, songs) {
            context.commit('setSongs', songs);
        },
        setNumberOfElements(context, numberOfElements) {
            context.commit('setNumberOfElements', numberOfElements);
        },
        setQuery(context, query) {
            context.commit('setQuery', query);
            if (query !== '') {
                context.commit('setOrderBy', ORDER_BY.SEARCH_SCORE);
            } else {
                context.commit('setOrderBy', ORDER_BY.DATE);
            }
        },
        setOrderBy(context, orderBy) {
            if (ORDER_BY[orderBy]) {
                context.commit('setOrderBy', orderBy);
                if (orderBy !== ORDER_BY.SEARCH_SCORE) {
                    context.commit('setQuery', '');
                }
            }
        }
    },
    getters: {
        filteredSongs: state => {
            const filteredSongs = state.songs.filter(song => {
                return state.orderBy !== ORDER_BY.SEARCH_SCORE || song.searchScore > 0;
            });
            filteredSongs.sort((song1, song2) => {
                if (state.orderBy === ORDER_BY.DATE) {
                    return song2.date.localeCompare(song1.date);
                } else if (state.orderBy === ORDER_BY.SEARCH_SCORE) {
                    return song2.searchScore - song1.searchScore;
                } else if (state.orderBy === ORDER_BY.NAME) {
                    return (song1.title).localeCompare(song2.title);
                } else {
                    return 0;
                }
            });
            return filteredSongs.slice(0, state.filters.numberOfElements);
        },
        getSongById: state => id => {
            return state.songs.filter(song => song.id == id)?.[0];
        }
    }
}
